import { z } from 'zod';
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email('Format email tidak valid'),
    password: z.string().min(1, 'Password wajib diisi'),
});
export const forgotPasswordSchema = z.object({
    email: z.string().trim().toLowerCase().email('Format email tidak valid'),
});
/**
 * Minimum length 8 characters, lowered from 12 on the user's instruction 2026-08-27.
 * One floor governs every entry point — change, reset, and user creation — because a
 * looser rule on any single one of them makes the stricter rule on the others
 * bypassable: create at 12, then immediately change to 8.
 *
 * The deploy-time floor in server/src/scripts/bootstrap.ts stays at 12. It guards the
 * BOOTSTRAP_ADMIN_PASSWORD env value for the first administrator, which is a deployment
 * hygiene check rather than an account policy.
 */
export const passwordSchema = z.string()
    .min(8, 'Password minimal 8 karakter')
    .max(200, 'Password maksimal 200 karakter');
export const resetPasswordSchema = z.object({
    token: z.string().min(1, 'Token wajib diisi'),
    password: passwordSchema,
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1, 'Password saat ini wajib diisi'),
    newPassword: passwordSchema,
});
